import { ModalOverlay, ModalDialog, ModalHeader, ModalBody, ModalFooter, Button } from '@flos/react-ui';

interface ConfirmationOverlayProps {
    open: boolean;
    close: () => void;
    onSkipWorkshopSelection: (action: string) => void;
}

const ConfirmationOverlay = (props: ConfirmationOverlayProps) => {
    const { open, close, onSkipWorkshopSelection } = props;

    return (
        <ModalOverlay isOpen={open} onDismiss={() => {}}>
            <ModalDialog>
                <ModalHeader></ModalHeader>
                <ModalBody>
                    <h4>Vil du springe værkstedsvalget over?</h4>
                    <p>
                        Hos de værksteder, vi samarbejder med, er du bl.a. garanteret høj kvalitet og udvidet garanti på
                        reparationen.
                    </p>
                </ModalBody>
                <ModalFooter>
                    <div style={{ textAlign: 'left' }}>
                        <Button
                            onClick={() => {
                                onSkipWorkshopSelection('shopsNotYetSearchedFor');
                                close();
                            }}
                        >
                            Vælg værksted
                        </Button>
                        <Button
                            className="flos-button flos-button-widest flos-button--no-fill"
                            onClick={() => {
                                onSkipWorkshopSelection('customerDoesNotWantShops');
                                close();
                            }}
                        >
                            Spring værkstedsvalg over
                        </Button>
                    </div>
                </ModalFooter>
            </ModalDialog>
        </ModalOverlay>
    );
};

export default ConfirmationOverlay;
